import { useEffect, useRef } from 'react';

export function useCheckVersion(intervalMs = 60000) {
  const checking = useRef(false);

  useEffect(() => {
    async function checkVersion() {
      if (checking.current) return;
      checking.current = true;

      try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        if (!response.ok) return;

        const { buildVersion } = await response.json();
        const currentVersion = localStorage.getItem('buildVersion');

        if (
          !currentVersion ||
          (currentVersion && currentVersion !== buildVersion)
        ) {
          console.log('Nova versão detectada. Recarregando...');
          localStorage.setItem('buildVersion', buildVersion);
          window.location.reload(true); // força reload do JS
        }
      } catch (err) {
        console.error('Erro ao verificar versão:', err);
      } finally {
        checking.current = false;
      }
    }

    checkVersion(); // executa uma vez ao montar
    const interval = setInterval(checkVersion, intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);
}
